"use client";

import { c as _c } from "react/compiler-runtime";
import { Table } from "@opensea/ui-kit";
import { range } from "es-toolkit";
import { ItemAttributesTableHeader } from "./ItemAttributesTableHeader";
import { ItemAttributesTableSkeletonRow } from "./ItemAttributesTableSkeletonRow";
export function ItemAttributesTableSkeleton(t0) {
  const $ = _c(5);
  const {
    overrides
  } = t0;
  let t1;
  if ($[0] !== overrides) {
    t1 = range(10).map(() => ({
      overrides
    }));
    $[0] = overrides;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ITEMS = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ItemAttributesTableHeader />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== ITEMS) {
    t3 = <Table header={t2} itemKey={_temp} items={ITEMS} renderRow={ItemAttributesTableSkeletonRow} size="sm" />;
    $[3] = ITEMS;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(_, index) {
  return index;
}